














import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'
import {Task, Signature} from '@/store/types'
import SurveyModel from '@/classes/SurveyModel'

@Component({})
export default class SurveyCanceled extends Vue {
  @Getter('taskCanceled') public taskCanceled!: Task
  @Mutation('unsetCanceledTask') public unsetCanceledTask: any
  public SurveyModel = SurveyModel

  public closeCanceledTask() {
      this.unsetCanceledTask()
  }
}
